export default __webpack_public_path__ + "static/media/list_bg.3dd5efea.jpg";